import { all, fork } from "redux-saga/effects";

//public
import AuthSaga from "./auth/login/saga";
import LayoutSaga from "./layout/saga";
import invoicesSaga from "./invoices/saga";
import configInitSaga from "./Config/saga";
import requisitionSaga from "./requisitions/saga"
import ProfileSaga from "./auth/profile/saga"

import areaSaga from "./Areas/saga";
import propertySaga from "./Property/saga";
import typePropertySaga from "./CatTypeProperties/saga";
import  reportsSaga  from "./Reports/saga";
import platformAdminSaga from "./PlatformAdmin/saga";

export default function* rootSaga() {
  yield all([
    fork(AuthSaga),
    fork(LayoutSaga),
    fork(invoicesSaga),
    fork(configInitSaga),
    fork(ProfileSaga),
    fork(requisitionSaga),
    fork(areaSaga),
    fork(propertySaga),
    fork(typePropertySaga),
    fork(reportsSaga),
    fork(platformAdminSaga),
  ]);
}
